import { render, staticRenderFns } from "./ClaimAccount.vue?vue&type=template&id=aafe6390"
import script from "./ClaimAccount.vue?vue&type=script&lang=ts"
export * from "./ClaimAccount.vue?vue&type=script&lang=ts"
import style0 from "./ClaimAccount.vue?vue&type=style&index=0&id=aafe6390&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports